'use strict';

const $ = window.jQuery;

export default class Forms {
    constructor() {
        $(document).on( 'frmFormComplete', function( event, form, response ) {
            $('html, body').animate({
                scrollTop: $('.frm_forms ').offset().top - 200
            }, 1000);
        });
    }
}
